var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { validatePackage } from '@progress/kendo-licensing';
import { packageMetadata } from './package-metadata';
var buttonTitle = 'Close';
/**
 * Represents the [KendoReact Notification component]({% slug overview_notification %}).
 */
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        validatePackage(packageMetadata);
        return _this;
    }
    /**
     * @hidden
     */
    Notification.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, className = _a.className, _b = _a.closable, closable = _b === void 0 ? Notification.defaultProps.closable : _b, _c = _a.type, type = _c === void 0 ? Notification.defaultProps.type : _c;
        return (React.createElement("div", { dir: this.props.dir, className: "k-notification-container" },
            React.createElement("div", { className: 'k-widget k-notification' +
                    (className ? " " + className : '') +
                    (type.style === 'none' ? '' : " k-notification-" + type.style) +
                    (closable ? ' k-notification-closable' : ''), style: this.props.style },
                React.createElement("div", { className: "k-notification-wrap" },
                    type.icon && React.createElement("span", { className: "k-icon k-i-" + type.style }),
                    React.createElement("div", { className: "k-notification-content" }, this.props.children),
                    closable && (React.createElement("a", __assign({ className: "k-icon k-i-close", title: buttonTitle, onClick: function (event) {
                            if (onClose) {
                                onClose.call(undefined, {
                                    target: _this,
                                    syntheticEvent: event,
                                    nativeEvent: event.nativeEvent
                                });
                            }
                        } }, (typeof closable !== 'boolean' ? closable : {}))))))));
    };
    /**
     * @hidden
     */
    Notification.propTypes = {
        className: PropTypes.string,
        closable: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        dir: PropTypes.string,
        style: PropTypes.object,
        type: PropTypes.shape({
            style: PropTypes.oneOf(['none', 'success', 'error', 'warning', 'info']),
            icon: PropTypes.bool
        }),
        onClose: PropTypes.func
    };
    /**
     * @hidden
     */
    Notification.defaultProps = {
        closable: false,
        type: {
            style: 'none',
            icon: true
        }
    };
    return Notification;
}(React.Component));
export default Notification;
//# sourceMappingURL=Notification.js.map